import { shippingAddressActions, useAppDispatch, useAppSelector } from '../../../data/store';
import { ChangeEvent } from 'react';
import { TaxIdStatusEnum } from '../../../enums/tax-id-status-enum';
import { updateControl } from '../../../../../../domain/validation/validation';

interface IAddressSummary {
    setEditAddressSelected: Function,
}

const AddressSummary = (props: IAddressSummary) => {

    const dispatch = useAppDispatch();
    const cartData = useAppSelector(store => store.root.cartData);
    const countries = useAppSelector(store => store.root.countries);

    const billToControl = useAppSelector(store => store.billingAddress.billToControl);
    const shipToControl = useAppSelector(store => store.shippingAddress.shipToControl);

    const billingAddressLine1Control = useAppSelector(store => store.billingAddress.addressLine1Control);
    const shippingAddressLine1Control = useAppSelector(store => store.shippingAddress.addressLine1Control);

    const billingAddressLine2Control = useAppSelector(store => store.billingAddress.addressLine2Control);
    const shippingAddressLine2Control = useAppSelector(store => store.shippingAddress.addressLine2Control);

    const billingCityControl = useAppSelector(store => store.billingAddress.cityControl);
    const shippingCityControl = useAppSelector(store => store.shippingAddress.cityControl);

    const billingZipCodeControl = useAppSelector(store => store.billingAddress.zipCodeControl);
    const shippingZipCodeControl = useAppSelector(store => store.shippingAddress.zipCodeControl);

    const billingCountryIdControl = useAppSelector(store => store.billingAddress.countryIdControl);
    const shippingCountryIdControl = useAppSelector(store => store.shippingAddress.countryIdControl);

    const billingStateIdControl = useAppSelector(store => store.billingAddress.stateIdControl);
    const shippingStateIdControl = useAppSelector(store => store.shippingAddress.stateIdControl);

    const billingPhoneControl = useAppSelector(store => store.billingAddress.phoneControl);
    const shippingPhoneControl = useAppSelector(store => store.shippingAddress.phoneControl);

    const billingPhoneCountryIdControl = useAppSelector(store => store.billingAddress.phoneCountryIdControl);
    const shippingPhoneCountryIdControl = useAppSelector(store => store.shippingAddress.phoneCountryIdControl);

    const taxIdControl = useAppSelector(store => store.billingAddress.taxIdControl);
    const taxIdSelectedStatusControl = useAppSelector(store => store.billingAddress.taxIdSelectedStatusControl);

    const billingSelectedCountry = countries.find(country => country.countryID.toString() === billingCountryIdControl.value.toString());
    const shippingSelectedCountry = countries.find(country => country.countryID.toString() === shippingCountryIdControl.value.toString());

    const billingSelectedState = billingSelectedCountry && billingSelectedCountry.states.find(state => state.stateID.toString() === billingStateIdControl.value.toString());
    const shippingSelectedState = shippingSelectedCountry && shippingSelectedCountry.states.find(state => state.stateID.toString() === shippingStateIdControl.value.toString());

    const billingSelectedPhoneCountry = countries.find(country => country.countryID.toString() === billingPhoneCountryIdControl.value.toString());
    const shippingSelectedPhoneCountry = countries.find(country => country.countryID.toString() === shippingPhoneCountryIdControl.value.toString());

    const isShippingDifferentFromBilling = useAppSelector(store => store.shippingAddress.isShippingDifferentFromBilling);

    const upsShippingCodeControl = useAppSelector(store => store.shippingAddress.upsShippingCodeControl);

    const editAddressHandler = () => {
        props.setEditAddressSelected(true);
    };

    /**
     * when the checkbox is checked ---> update the extra cart data, save it to storage in a special key,
     * open the form for editing, and show the shipping form
     */
    const isShippingDifferentFromBillingHandler = (evt: ChangeEvent) => {
        const $target = evt.target as HTMLInputElement;

        dispatch(
            shippingAddressActions.setIsShippingDifferentFromBilling($target.checked)
        );

        props.setEditAddressSelected(true);

        // reset shipping drop-down
        dispatch(
            shippingAddressActions.main({
                upsShippingOptions: [],
                upsShippingError: '',
            })
        );

        dispatch(
            shippingAddressActions.setControl({
                controlName: 'upsShippingCodeControl',
                control: updateControl(upsShippingCodeControl, '', true)
            })
        );
    };

    return (
        <div className="text-lg text-gray-700">
            <p className="text-gray-500 text-base mb-2">Bill To:</p>

            <p>{ billToControl.value }</p>
            <p>{ billingAddressLine1Control.value }</p>
            { billingAddressLine2Control.value && <p>{ billingAddressLine2Control.value }</p> }

            <p>
                { billingCityControl.value }
                {
                    ((billingSelectedState && billingSelectedState.stateDisplayName) || billingZipCodeControl.value) &&
                    <span>, </span>
                }

                {
                    billingSelectedState && billingSelectedState.stateDisplayName && <span> { billingSelectedState.stateDisplayName } </span>
                }

                { billingZipCodeControl.value }
            </p>


            <p>{ billingSelectedCountry && <span>{ billingSelectedCountry.countryDisplayName }</span> }</p>

            <p>Phone: { billingSelectedPhoneCountry ? `+${ billingSelectedPhoneCountry.phoneCode }` : ''} { billingPhoneControl.value }</p>

            {
                taxIdSelectedStatusControl.value === TaxIdStatusEnum.YES && taxIdControl.value &&
                <p>Tax / VAT number: { taxIdControl.value }</p>
            }

            <button type="button" className="text-tiny text-blue-200 font-bold my-4" onClick={ editAddressHandler }>Edit Address</button>

            {
                cartData.isShippingNeeded &&
                <>
                    <p>
                        <label className="flex items-center">
                            <input
                                type="checkbox"
                                className="mr-3"
                                data-qa="cart-step3-ship-diff-cb"
                                checked={ isShippingDifferentFromBilling }
                                name="isShippingDifferentFromBilling"
                                onChange={ isShippingDifferentFromBillingHandler }
                            />
                            <span className="text-base">Shipping address is different than billing address</span>
                        </label>
                    </p>

                    {
                        isShippingDifferentFromBilling && (
                            <>
                                <p className="text-gray-500 text-base mb-2">Ship To:</p>

                                <p>{ shipToControl.value }</p>
                                <p>{ shippingAddressLine1Control.value }</p>
                                { shippingAddressLine2Control.value && <p>{ shippingAddressLine2Control.value }</p> }

                                <p>
                                    { shippingCityControl.value }
                                    {
                                        ((shippingSelectedState && shippingSelectedState.stateDisplayName) || shippingZipCodeControl.value) &&
                                        <span>, </span>
                                    }

                                    {
                                        shippingSelectedState && shippingSelectedState.stateDisplayName && <span> { shippingSelectedState.stateDisplayName } </span>
                                    }

                                    { shippingZipCodeControl.value }
                                </p>


                                <p>{ shippingSelectedCountry && <span>{ shippingSelectedCountry.countryDisplayName }</span> }</p>

                                <p>Phone: { shippingSelectedPhoneCountry ? `+${ shippingSelectedPhoneCountry.phoneCode }` : ''} { shippingPhoneControl.value }</p>

                                <button
                                    type="button"
                                    className="text-tiny text-blue-200 font-bold my-4"
                                    data-qa="cart-step3-edit-address-link"
                                    onClick={ editAddressHandler }>Edit Address</button>

                            </>
                        )
                    }
                </>
            }

        </div>
    )
};

export default AddressSummary;